import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const STORAGE_KEY = 'pagali_welcome_shown_v1';

export default function WelcomeActivationModal() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    const uid = (window as any)._pagali_uid ?? '';
    const key = `${STORAGE_KEY}_${uid}`;
    if (localStorage.getItem(key)) return;
    // Mostrar após 1.5s para não bloquear o carregamento inicial
    const t = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(t);
  }, [isAuthenticated]);

  const dismiss = (key: string) => {
    localStorage.setItem(key, '1');
    setVisible(false);
  };

  if (!visible) return null;

  const uid = (window as any)._pagali_uid ?? '';
  const key = `${STORAGE_KEY}_${uid}`;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
    }}>
      <div style={{
        background: '#fff', borderRadius: '20px', maxWidth: '420px', width: '100%',
        overflow: 'hidden', boxShadow: '0 24px 64px rgba(90,45,145,0.25)',
      }}>
        {/* Header roxo */}
        <div style={{
          background: 'linear-gradient(135deg, #5a2d91 0%, #7c3aed 100%)',
          padding: '32px 28px 24px', textAlign: 'center',
        }}>
          <div style={{
            width: 64, height: 64, background: 'rgba(255,255,255,0.15)',
            borderRadius: '50%', margin: '0 auto 16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 32,
          }}>🇨🇻</div>
          <h2 style={{ color: '#fff', margin: 0, fontSize: 22, fontWeight: 800 }}>
            Conta activa!
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', margin: '8px 0 0', fontSize: 14 }}>
            A tua conta Pagali está aprovada e pronta a usar
          </p>
        </div>

        {/* Body */}
        <div style={{ padding: '28px' }}>
          <p style={{ margin: '0 0 20px', fontSize: 15, color: '#444466', lineHeight: 1.7 }}>
            Agora podes pagar contas, transferir e muito mais — tudo num só lugar.
            Faz o teu primeiro pagamento em menos de 1 minuto. 💜
          </p>

          <button
            onClick={() => { dismiss(key); navigate('/payments'); }}
            style={{
              width: '100%', padding: '16px', borderRadius: '12px',
              background: 'linear-gradient(135deg, #5a2d91, #7c3aed)',
              color: '#fff', border: 'none', fontSize: 16, fontWeight: 700,
              cursor: 'pointer', marginBottom: '12px',
            }}
          >
            Fazer primeiro pagamento →
          </button>

          <button
            onClick={() => dismiss(key)}
            style={{
              width: '100%', padding: '12px', borderRadius: '12px',
              background: 'transparent', color: '#888', border: '1px solid #e5e7eb',
              fontSize: 14, cursor: 'pointer',
            }}
          >
            Ver mais tarde
          </button>
        </div>
      </div>
    </div>
  );
}
